<template>
    <div id="train">
        <div class="banner">
            <img src="../../assets/img/banner.png" draggable="false" />
        </div>
        <TrainList :dataArray="trainList" />
    </div>
</template>

<script>
import TrainList from "../Common/TrainList";

export default {
    name: "Train",
    data() {
        return {
            trainList: []
        };
    },
    components: { TrainList },
    created() {},
    mounted() {
        this.getTrainData();
    },
    methods: {
        getTrainData() {
            this.$loading({
                background: "rgba(0, 0, 0, 0.7)",
                text: "拼命加载中"
            });
            this.$axios
                .post("/web/academy/queryAcademy", this.$qs.stringify({ pageCount: 20, pageIndex: 1 }))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        this.trainList = data.result_data;
                    } else {
                        this.$message.error(data.message);
                    }
                    this.$loading().close();
                })
                .catch(err => {
                    this.$loading().close();
                    this.$message.error(err);
                });
        }
    }
};
</script>

<style scoped>
#train {
    width: 100%;
    background-color: #fff;
}

.banner {
    margin-bottom: 30px;
}

.banner > img {
    display: block;
    width: 100%;
}
</style>
